import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import _imports_0 from '@/assets/ai/copy.svg';
import _imports_1 from '@/assets/ai/delete.svg';
const _hoisted_1 = {
  key: 0,
  class: "left-message message-item"
};
const _hoisted_2 = {
  class: "avatar"
};
const _hoisted_3 = {
  class: "message"
};
const _hoisted_4 = {
  class: "left-btns"
};
const _hoisted_5 = {
  key: 1,
  class: "right-message message-item"
};
const _hoisted_6 = {
  class: "avatar"
};
const _hoisted_7 = {
  class: "message"
};
const _hoisted_8 = {
  class: "right-text-container"
};
const _hoisted_9 = {
  class: "right-text"
};
const _hoisted_10 = {
  class: "right-btns"
};
import { toRefs, watch } from 'vue';
import { formatDate } from '@/utils/formatTime';
import MarkdownView from '@/components/MarkdownView/index.vue';
import MessageKnowledge from './MessageKnowledge.vue';
import { useClipboard } from '@vueuse/core';
import { Edit, RefreshRight } from '@element-plus/icons-vue';
import { ChatMessageApi } from '@/api/ai/chat/message';
import { useUserStore } from '@/store/modules/user';
import userAvatarDefaultImg from '@/assets/imgs/avatar.gif';
// import roleAvatarDefaultImg from '@/assets/ai/pi.svg'
import roleAvatarDefaultImg from '@/assets/ai/lh.png';
import { computed, nextTick, onMounted, ref } from 'vue';
import { useMessage } from '@/hooks/web/useMessage';
export default /*@__PURE__*/_defineComponent({
  __name: 'MessageList',
  props: {
    conversation: {
      type: Object,
      required: true
    },
    list: {
      type: Array,
      required: true
    }
  },
  emits: ['onDeleteSuccess', 'onRefresh', 'onEdit', 'onListChange'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const message = useMessage(); // 消息弹窗
    const {
      copy
    } = useClipboard(); // 初始化 copy 到粘贴板
    const userStore = useUserStore();
    // 判断“消息列表”滚动的位置(用于判断是否需要滚动到消息最下方)
    const messageContainer = ref(null);
    // const isScrolling = ref(false) //用于判断用户是否在滚动
    const userAvatar = computed(() => userStore.user.avatar || userAvatarDefaultImg);
    const roleAvatar = computed(() => props.conversation.roleAvatar ?? roleAvatarDefaultImg);
    // 定义 props
    const props = __props;
    const {
      list
    } = toRefs(props); // 消息列表
    const emits = __emit; // 定义 emits
    // ============ 处理对话滚动 ==============
    /** 滚动到底部 */
    const scrollToBottom = async isIgnore => {
      // 注意要使用 nextTick 以免获取不到 dom
      await nextTick();
      // if (isIgnore || !isScrolling.value) {
      //   messageContainer.value.scrollTop =
      //     messageContainer.value.scrollHeight - messageContainer.value.offsetHeight
      // }
    };
    function handleScroll() {
      const scrollContainer = messageContainer.value;
      const scrollTop = scrollContainer.scrollTop;
      const scrollHeight = scrollContainer.scrollHeight;
      const offsetHeight = scrollContainer.offsetHeight;
      if (scrollTop + offsetHeight < scrollHeight - 100) {
        // 用户开始滚动并在最底部之上，取消保持在最底部的效果
        // isScrolling.value = true
      } else {
        // 用户停止滚动并滚动到最底部，开启保持到最底部的效果
        // isScrolling.value = false
      }
    }
    /** 回到底部 */
    const handleGoBottom = async () => {
      const scrollContainer = messageContainer.value;
      scrollContainer.scrollTop = scrollContainer.scrollHeight;
    };
    /** 回到顶部 */
    const handlerGoTop = async () => {
      const scrollContainer = messageContainer.value;
      scrollContainer.scrollTop = 0;
    };
    __expose({
      scrollToBottom,
      handlerGoTop
    }); // 提供方法给 parent 调用
    // ============ 处理消息操作 ==============
    /** 复制 */
    const copyContent = async content => {
      await copy(content);
      message.success('复制成功！');
    };
    /** 删除 */
    const onDelete = async id => {
      // 删除 message
      await ChatMessageApi.deleteChatMessage(id);
      message.success('删除成功！');
      // 回调
      emits('onDeleteSuccess');
    };
    /** 刷新 */
    const onRefresh = async message => {
      emits('onRefresh', message);
    };
    /** 编辑 */
    const onEdit = async message => {
      emits('onEdit', message);
    };
    // 修改 watch 监听器
    watch(() => list.value, async () => {
      // 通知父组件滚动到底部
      emits('onListChange');
    }, {
      deep: true,
      flush: 'post'
    });
    /** 初始化 */
    onMounted(async () => {
      messageContainer.value.addEventListener('scroll', handleScroll);
    });
    return (_ctx, _cache) => {
      const _component_el_avatar = _resolveComponent("el-avatar");
      const _component_el_text = _resolveComponent("el-text");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      return _openBlock(), _createElementBlock("div", {
        ref_key: "messageContainer",
        ref: messageContainer,
        class: "relative"
      }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(list), (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "chat-list",
          key: index
        }, [item.type !== 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_avatar, {
          shape: "square",
          src: roleAvatar.value,
          size: "default"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
          class: "time"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formatDate)(item.createTime)), 1)]),
          _: 2
        }, 1024)]), _createElementVNode("div", {
          class: "left-text-container",
          ref_for: true,
          ref: "markdownViewRef"
        }, [_createVNode(MarkdownView, {
          class: "left-text",
          content: item.content
        }, null, 8, ["content"]), item.segments ? (_openBlock(), _createBlock(MessageKnowledge, {
          key: 0,
          segments: item.segments
        }, null, 8, ["segments"])) : _createCommentVNode("", true)], 512), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          class: "btn-cus",
          link: "",
          onClick: $event => copyContent(item.content)
        }, {
          default: _withCtx(() => _cache[0] || (_cache[0] = [_createElementVNode("img", {
            class: "btn-image",
            src: _imports_0
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"]), item.id > 0 ? (_openBlock(), _createBlock(_component_el_button, {
          key: 0,
          class: "btn-cus",
          link: "",
          onClick: $event => onDelete(item.id)
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createElementVNode("img", {
            class: "btn-image h-17px",
            src: _imports_1
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"])) : _createCommentVNode("", true)])])])) : _createCommentVNode("", true), item.type === 'user' ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_el_avatar, {
          src: userAvatar.value
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_7, [_createElementVNode("div", null, [_createVNode(_component_el_text, {
          class: "time"
        }, {
          default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(formatDate)(item.createTime)), 1)]),
          _: 2
        }, 1024)]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, _toDisplayString(item.content), 1)]), _createElementVNode("div", _hoisted_10, [_createVNode(_component_el_button, {
          class: "btn-cus",
          link: "",
          onClick: $event => copyContent(item.content)
        }, {
          default: _withCtx(() => _cache[2] || (_cache[2] = [_createElementVNode("img", {
            class: "btn-image",
            src: _imports_0
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          class: "btn-cus",
          link: "",
          onClick: $event => onDelete(item.id)
        }, {
          default: _withCtx(() => _cache[3] || (_cache[3] = [_createElementVNode("img", {
            class: "btn-image h-17px mr-12px",
            src: _imports_1
          }, null, -1)])),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          class: "btn-cus",
          link: "",
          onClick: $event => onRefresh(item)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: "17"
          }, {
            default: _withCtx(() => [_createVNode(_unref(RefreshRight))]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          class: "btn-cus",
          link: "",
          onClick: $event => onEdit(item)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_icon, {
            size: "17"
          }, {
            default: _withCtx(() => [_createVNode(_unref(Edit))]),
            _: 1
          })]),
          _: 2
        }, 1032, ["onClick"])])])])) : _createCommentVNode("", true)]);
      }), 128))], 512);
    };
  }
});